import { render, staticRenderFns } from "./buttongroup.vue?vue&type=template&id=37a34025&"
import script from "./buttongroup.vue?vue&type=script&lang=js&"
export * from "./buttongroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports